export * from './IconLayoutGradient';
export { default as IconLayoutGradient } from './IconLayoutGradient';
